<form [formGroup]="durationForm" (ngSubmit)="onSubmit($event)">
  <h3 mat-dialog-title>Выберите продолжительность</h3>
  <div mat-dialog-content>
    <div class="form">
      <mat-form-field>
        <mat-label>часы</mat-label>
        <input matInput formControlName="hours"
               placeholder="Введите часы"
               type="number"
               min="0"
               max="23"
               autocomplete="off" 
               >
      </mat-form-field>
      <mat-form-field>
        <mat-label>минуты</mat-label>
        <input matInput formControlName="minutes"
               placeholder="Введите минуты"
               type="number"
               min="0"
               max="59"
               autocomplete="off"
               >
      </mat-form-field>
      <button mat-icon-button
              matTooltip="Сбросить"
              type="button"
              (click)="onReset()">
        <mat-icon>clear</mat-icon>
      </button>
    </div>
  </div>
  <div mat-dialog-actions align="end">
    <button mat-button
            type="button"
            (click)="onCancel()">Отмена
    </button>
    <button mat-button color="primary"
            type="submit"
            (click)="onSubmit($event)">Установить
    </button>
  </div>
</form>
